module.exports = "/images/lena-3.png?4bfb9615de55fd81fb4726b94810dddc";